import React, { useEffect, useState } from "react";
import { api, dateFormat } from "../../lib/api";

export default function SignupApprovals() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/admin/signup-approvals").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const handle = async (uid, freigegeben, grund = null) => {
    setBusy(uid);
    await api.post(`/admin/signup-approvals/${uid}`, { freigegeben, ablehnungsgrund: grund });
    setBusy(null);
    load();
  };

  return (
    <div className="space-y-5" data-testid="signup-approvals-page">
      <h1 className="text-3xl font-heading font-bold text-falke-blue">Self-Signup Freischaltung</h1>
      {items.length === 0 ? (
        <div className="falke-card p-10 text-center text-falke-anthracite/60">Keine offenen Anfragen.</div>
      ) : (
        <div className="space-y-3">
          {items.map((u) => (
            <div key={u.id} className="falke-card p-5" data-testid={`approval-${u.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="font-heading text-lg text-falke-blue">{u.name}</div>
                  <div className="text-sm text-falke-anthracite/70">{u.email} · {u.telefon || "—"}</div>
                  <div className="text-sm text-falke-anthracite/70">Anlage: {u.anlagenadresse || "—"} · Installation: {u.installation_datum_ca || "—"}</div>
                  {u.rechnungsnummer_optional && <div className="text-xs text-falke-anthracite/60">Rechnungsnr: {u.rechnungsnummer_optional}</div>}
                  <div className="text-xs text-falke-anthracite/55 mt-1">Eingereicht: {dateFormat(u.erstellt_am)}</div>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => handle(u.id, true)} disabled={busy === u.id} className="btn-primary" data-testid={`approve-${u.id}`}>Freigeben</button>
                  <button onClick={() => {
                    const grund = prompt("Ablehnungsgrund?");
                    if (grund !== null) handle(u.id, false, grund);
                  }} className="btn-outline" data-testid={`reject-${u.id}`}>Ablehnen</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
